import React, { memo } from "react";
import { Route, Routes } from "react-router-dom";
import { AddRole } from "./addRole";
import { routesName } from "core";
import { RolesList } from "./rolesList";
import { EditRole } from "./editRole";
import { RoleDetail } from "./roleDetail";


const Roles = memo(() => {
  return (
    <Routes>
      <Route path={routesName.ADDROLE} element={<AddRole />} />
      <Route path={routesName.EDITROLE} element={<EditRole />} />
      <Route path={routesName.ROLESLIST} element={<RolesList />} />
      <Route path={routesName.ROLEDETAIL} element={<RoleDetail />} />
    </Routes>
  );
});

export { Roles };
